<script lang="ts" setup>
import { computed } from 'vue';
import DefaultReviewerSelector, {
  type DefaultReviewerSelectorProps,
} from '../DefaultReviewerSelector.vue';
import type {
  DefaultReviewerSelectorAction,
  DefaultReviewerSelectorMode,
} from '../types';
import { useDefaultReviewerSelectorData } from './useDefaultReviewerSelectorData';

export type DefaultReviewerSelectorDataProps = {
  projectId: string;
  mode?: DefaultReviewerSelectorMode;
};

const props = defineProps<DefaultReviewerSelectorDataProps>();

const { projectUsers, defaultReviewers } = useDefaultReviewerSelectorData(
  () => props.projectId,
);

const handleAction = (payload: DefaultReviewerSelectorAction): void => {
  switch (payload.type) {
    case 'save':
      defaultReviewers.mutation.mutate(
        payload.payload.map((id, i) => ({ id, ranking: i })),
      );
      break;
  }
};

const selectorProps = computed<DefaultReviewerSelectorProps>(() => {
  return {
    allReviewers: (projectUsers.query.data.value ?? []).map((u) => ({
      id: u.id,
      name: u.name,
      email: u.email,
      role: u.role,
    })),
    defaultReviewers: (defaultReviewers.query.data.value ?? []).map((r) => ({
      id: r.id,
      name: r.name,
      email: r.email,
      role: r.role,
    })),
    initialSelectedIds: (defaultReviewers.query.data.value ?? []).map(
      (r) => r.id,
    ),
    isSaving: defaultReviewers.mutation.isPending.value,
    mode: props.mode,
  };
});
</script>

<template>
  <DefaultReviewerSelector v-bind="selectorProps" @action="handleAction" />
</template>
